module.exports = __webpack_public_path__ + "media/application/images/icons/icon-fertilizer-1a41b99ac6e713c14d7858994c5af844.svg";